export const calculateProgressPercentage = (current: number, total: number) => {
  if (total === 0) {
    return 0;
  }
  const percentage = (current / total) * 100;
  return Math.floor(percentage * 100) / 100;
};
